import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { key: 0 }

import { ref, onMounted, inject } from "vue";
import UserService from "../../services/UserService";
import SystemService from "@/projects/tenant/modules/system/services/SystemService";
import { ElNotification } from "element-plus";
import { getCurrentInstance } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserRole',
  setup(__props) {

const { proxy } = getCurrentInstance();
const isLoading = ref(false);
const data = ref<any>([]);
const userInfos = inject<any>("userInfos");
const partyId = ref(userInfos.value.partyId);
const currentRoles = ref<any>();

const getPermission = async () => {
  try {
    const result = await SystemService.getPermissionUsersById(partyId.value);
    currentRoles.value = result.user.roles;
  } catch (e) {
    console.error(e);
  }
};
const fetchData = async () => {
  isLoading.value = true;
  try {
    data.value = await UserService.queryUserRoles();
    await getPermission();
  } catch (error) {
    console.error(error);
  }
  isLoading.value = false;
};

const processOptions = async () => {
  isLoading.value = true;
  if (!proxy.$can("SuperAdmin")) {
    data.value = data.value.filter((item: any) => item.id != 10);
  }
  if (!proxy.$can("TenantAdmin")) {
    data.value = [];
  }
  isLoading.value = false;
};

const toggleRoles = async (item: any) => {
  isLoading.value = true;
  try {
    if (currentRoles.value.includes(item.id)) {
      await UserService.addUserRole(partyId.value, item.id);
    } else {
      await UserService.removeUserRole(partyId.value, item.id);
    }
    ElNotification({
      title: "Success",
      message: item.name + " updated successfully",
      type: "success",
    });
  } catch (error) {
    console.error(error);
    if (currentRoles.value.includes(item.id)) {
      currentRoles.value = currentRoles.value.filter(
        (role) => role !== item.id
      );
    } else {
      currentRoles.value.push(item.id);
    }
    ElNotification({
      title: "Error",
      message: "Failed to update " + item.name,
      type: "error",
    });
  }
  isLoading.value = false;
};

onMounted(async () => {
  await fetchData();
  await processOptions();
});

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_checkbox_group, {
        modelValue: currentRoles.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentRoles).value = $event)),
        class: "row row-cols-5"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_checkbox, {
              key: item.id,
              label: item.id,
              size: "large",
              class: "m-3",
              border: "",
              disabled: isLoading.value,
              onChange: ($event: any) => (toggleRoles(item))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(item.name), 1),
                (_ctx.$can('SuperAdmin'))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "- " + _toDisplayString(item.id), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["label", "disabled", "onChange"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})